export const WAITING = 'WAITING';
export const RENDERING = 'RENDERING';
export const COMPLETE = 'COMPLETE';
export const RERENDER = 'RERENDER';
